/**
 * Empty / misconfigured state. Rendered when the URL doesn't contain
 * a public_key, which means the user landed here via a malformed
 * snippet, a stale bookmark, or by pasting the bare register subdomain
 * into a browser.
 */
import './NotConfigured.css';

export function NotConfigured() {
  return (
    <div className="tn-not-configured">
      <h1>TourneyNation Registration</h1>
      <p>
        Use the link your tournament organizer shared with you to start
        registering, or visit{' '}
        <a href="https://tourneynation.com">tourneynation.com</a> to
        find an event.
      </p>
    </div>
  );
}
